import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AdminRewardsSummaryItem,
  RewardsHistoryColumn,
} from '../../../../../rewards/models/rewards-v2.models';
import { RewardsEarningSummaryTableComponent } from '../rewards-earning-summary-table/rewards-earning-summary-table.component';

@Component({
  selector: 'app-rewards-summary-tab',
  standalone: true,
  imports: [CommonModule, RewardsEarningSummaryTableComponent],
  templateUrl: './rewards-summary-tab.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./rewards-summary-tab.component.scss'],
})
export class RewardsSummaryTabComponent {
  @Input() columns: RewardsHistoryColumn[] = [];
  @Input() items: AdminRewardsSummaryItem[] = [];
  @Input() loading = false;
}
